import React, { ReactNode } from 'react';
import { Text } from '../../components/Text';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
    wrapper: {
        width: '100%',
        marginTop: 20,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
        gap: 30
    }
}));

export const CalendarFooter: React.FC<{children: ReactNode}> = ({ children }) => {

    const classes = useStyles();

    return (
        <div style={{padding: 20}}>

            <Text type="title">Keep up the great work!!</Text>

            <div className={classes.wrapper}>
                {children}
            </div>

        </div>
    );
};
